import { isTextSelection as e, posToDOMRect as t } from "@tiptap/core";
import { arrow as n, autoPlacement as r, computePosition as i, flip as a, hide as o, inline as s, offset as c, shift as l, size as u } from "@floating-ui/dom";
import { NodeSelection as d, Plugin as f, PluginKey as p } from "@tiptap/pm/state";
import { CellSelection as m } from "@tiptap/pm/tables";
//#region src/components/bubble-menu/bubble-menu-plugin.ts
function h(e, t) {
	let n = Math.min(e.top, t.top), r = Math.max(e.bottom, t.bottom), i = Math.min(e.left, t.left), a = Math.max(e.right, t.right) - i, o = r - n;
	return new DOMRect(i, n, a, o);
}
var g = class {
	get middlewares() {
		let e = [];
		return this.floatingUIOptions.flip && e.push(a(typeof this.floatingUIOptions.flip == "boolean" ? void 0 : this.floatingUIOptions.flip)), this.floatingUIOptions.shift && e.push(l(typeof this.floatingUIOptions.shift == "boolean" ? void 0 : this.floatingUIOptions.shift)), this.floatingUIOptions.offset && e.push(c(typeof this.floatingUIOptions.offset == "boolean" ? void 0 : this.floatingUIOptions.offset)), this.floatingUIOptions.arrow && e.push(n(this.floatingUIOptions.arrow)), this.floatingUIOptions.size && e.push(u(typeof this.floatingUIOptions.size == "boolean" ? void 0 : this.floatingUIOptions.size)), this.floatingUIOptions.autoPlacement && e.push(r(typeof this.floatingUIOptions.autoPlacement == "boolean" ? void 0 : this.floatingUIOptions.autoPlacement)), this.floatingUIOptions.hide && e.push(o(typeof this.floatingUIOptions.hide == "boolean" ? void 0 : this.floatingUIOptions.hide)), this.floatingUIOptions.inline && e.push(s(typeof this.floatingUIOptions.inline == "boolean" ? void 0 : this.floatingUIOptions.inline)), e;
	}
	get virtualElement() {
		let { selection: e } = this.editor.state, n = this.getReferencedVirtualElement?.();
		if (n) return n;
		if (!this.view?.dom?.parentNode) return;
		let r = t(this.view, e.from, e.to), i = {
			getBoundingClientRect: () => r,
			getClientRects: () => [r]
		};
		if (e instanceof d) {
			let t = this.view.nodeDOM(e.from), n = t.dataset.nodeViewWrapper ? t : t.querySelector("[data-node-view-wrapper]");
			n && (t = n), t && (i = {
				getBoundingClientRect: () => t.getBoundingClientRect(),
				getClientRects: () => [t.getBoundingClientRect()]
			});
		}
		if (e instanceof m) {
			let { $anchorCell: t, $headCell: n } = e, r = t ? t.pos : n.pos, a = n ? n.pos : t.pos, o = this.view.nodeDOM(r), s = this.view.nodeDOM(a);
			if (!o || !s) return;
			let c = o === s ? o.getBoundingClientRect() : h(o.getBoundingClientRect(), s.getBoundingClientRect());
			i = {
				getBoundingClientRect: () => c,
				getClientRects: () => [c]
			};
		}
		return i;
	}
	constructor({ editor: t, element: n, view: r, updateDelay: i = 250, resizeDelay: a = 60, shouldShow: o, appendTo: s, getReferencedVirtualElement: c, options: l }) {
		this.preventHide = !1, this.isVisible = !1, this.scrollTarget = window, this.floatingUIOptions = {
			strategy: "absolute",
			placement: "top",
			offset: 8,
			flip: {},
			shift: {},
			arrow: !1,
			size: !1,
			autoPlacement: !1,
			hide: !1,
			inline: !1,
			onShow: void 0,
			onHide: void 0,
			onUpdate: void 0,
			onDestroy: void 0
		}, this.shouldShow = ({ view: t, state: n, from: r, to: i }) => {
			let { doc: a, selection: o } = n, { empty: s } = o, c = !a.textBetween(r, i).length && e(n.selection), l = this.element.contains(document.activeElement);
			return !(!(t.hasFocus() || l) || s || c || !this.editor.isEditable);
		}, this.mousedownHandler = () => {
			this.preventHide = !0;
		}, this.documentMousedownHandler = (e) => {
			let t = e.target;
			this.element.contains(t) || this.view.dom.contains(t) || t.closest?.("[data-base-ui-portal]") || this.hide();
		}, this.dragstartHandler = () => {
			this.hide();
		}, this.resizeHandler = () => {
			this.resizeDebounceTimer && clearTimeout(this.resizeDebounceTimer), this.resizeDebounceTimer = window.setTimeout(() => {
				this.updatePosition();
			}, this.resizeDelay);
		}, this.focusHandler = () => {
			setTimeout(() => this.update(this.editor.view));
		}, this.blurHandler = ({ event: e }) => {
			if (this.editor.isDestroyed) {
				this.destroy();
				return;
			}
			if (this.preventHide) {
				this.preventHide = !1;
				return;
			}
			e?.relatedTarget && this.element.parentNode?.contains(e.relatedTarget) || e?.relatedTarget !== this.editor.view.dom && this.hide();
		}, this.handleDebouncedUpdate = (e, t) => {
			let n = !t?.selection.eq(e.state.selection), r = !t?.doc.eq(e.state.doc);
			!n && !r || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
				this.updateHandler(e, n, r, t);
			}, this.updateDelay));
		}, this.updateHandler = (e, t, n, r) => {
			let { composing: i } = e;
			if (!(i || !t && !n)) {
				if (!this.getShouldShow(r)) {
					this.hide();
					return;
				}
				this.updatePosition(), this.show();
			}
		}, this.transactionHandler = ({ transaction: e }) => {
			e.getMeta("bubbleMenu") === "updatePosition" && this.updatePosition();
		}, this.editor = t, this.element = n, this.view = r, this.updateDelay = i, this.resizeDelay = a, this.appendTo = s, this.scrollTarget = l?.scrollTarget ?? window, this.getReferencedVirtualElement = c, this.floatingUIOptions = {
			...this.floatingUIOptions,
			...l
		}, this.element.tabIndex = 0, o && (this.shouldShow = o), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.editor.on("transaction", this.transactionHandler), window.addEventListener("resize", this.resizeHandler), this.scrollTarget.addEventListener("scroll", this.resizeHandler), document.addEventListener("mousedown", this.documentMousedownHandler), this.update(r, r.state), this.getShouldShow() && (this.show(), this.updatePosition());
	}
	updatePosition() {
		let e = this.virtualElement;
		e && i(e, this.element, {
			placement: this.floatingUIOptions.placement,
			strategy: this.floatingUIOptions.strategy,
			middleware: this.middlewares
		}).then(({ x: e, y: t, strategy: n }) => {
			this.element.style.width = "max-content", this.element.style.position = n, this.element.style.left = `${e}px`, this.element.style.top = `${t}px`, this.isVisible && this.floatingUIOptions.onUpdate && this.floatingUIOptions.onUpdate();
		});
	}
	update(e, t) {
		let { state: n } = e, r = n.selection.from !== n.selection.to;
		if (this.updateDelay > 0 && r) {
			this.handleDebouncedUpdate(e, t);
			return;
		}
		let i = !t?.selection.eq(e.state.selection), a = !t?.doc.eq(e.state.doc);
		this.updateHandler(e, i, a, t);
	}
	getShouldShow(e) {
		let { state: t } = this.view, { selection: n } = t, { ranges: r } = n, i = Math.min(...r.map((e) => e.$from.pos)), a = Math.max(...r.map((e) => e.$to.pos));
		return this.shouldShow?.({
			editor: this.editor,
			element: this.element,
			view: this.view,
			state: t,
			oldState: e,
			from: i,
			to: a
		}) || !1;
	}
	show() {
		this.isVisible ||= (this.element.style.visibility = "visible", this.element.style.opacity = "1", ((typeof this.appendTo == "function" ? this.appendTo() : this.appendTo) ?? this.view.dom.parentElement)?.appendChild(this.element), this.floatingUIOptions.onShow && this.floatingUIOptions.onShow(), !0);
	}
	hide() {
		this.isVisible &&= (this.element.style.visibility = "hidden", this.element.style.opacity = "0", this.element.remove(), this.floatingUIOptions.onHide && this.floatingUIOptions.onHide(), !1);
	}
	destroy() {
		this.hide(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), window.removeEventListener("resize", this.resizeHandler), this.scrollTarget.removeEventListener("scroll", this.resizeHandler), document.removeEventListener("mousedown", this.documentMousedownHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler), this.editor.off("transaction", this.transactionHandler), this.floatingUIOptions.onDestroy && this.floatingUIOptions.onDestroy();
	}
}, _ = (e) => new f({
	key: typeof e.pluginKey == "string" ? new p(e.pluginKey) : e.pluginKey,
	view: (t) => new g({
		view: t,
		...e
	})
});
//#endregion
export { _ as BubbleMenuPlugin, g as BubbleMenuView };
